import { styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../common/hooks';
import { initializeAdviceClient } from '../../../features/client';
import { initializeGoals } from '../../../features/client-goals';
import { resetEws } from '../../../features/ews';
import { ContinueStepButton, Typography } from '../../../components/atoms';
import { useTranslation } from 'react-i18next';
import { ADVISOR_ROUTES } from '../../../routes/routeConstants';
import { ReactComponent as ProfileIconography } from '../../../assets/icons/profile_iconography.svg';

export const EmptyClients = () => {
    const navigate = useNavigate();

    const { t } = useTranslation();

    const dispatch = useAppDispatch();

    const navigateToCreateClient = () => {
        // initialize page upon landing on /createclient
        dispatch(initializeAdviceClient());
        dispatch(initializeGoals());
        dispatch(resetEws());
        navigate(ADVISOR_ROUTES.CLIENT_PROFILE);
    };

    return (
        <ClientConsoleContainer>
            <EmptyStateContainer>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '24px'
                    }}
                >
                    <StyledIconContainer>
                        <ProfileIconography />
                    </StyledIconContainer>
                    <StyledTitle variant="h2" label={t('TEXT_LETS_GET_STARTED')} />
                    <ContinueStepButton
                        sx={{
                            padding: '10px 24px'
                        }}
                        variant="contained"
                        onClick={navigateToCreateClient}
                        data-heap-id="create-new-plan"
                    >
                        {t('TEXT_CREATE_A_NEW_PLAN')}
                    </ContinueStepButton>
                </div>
            </EmptyStateContainer>
        </ClientConsoleContainer>
    );
};

const ClientConsoleContainer = styled('div')(() => ({
    display: 'block',
    padding: '0 40px',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    maxHeight: '215px'
}));

const EmptyStateContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: '1',
    borderRadius: '8px',
    border: `1px solid ${theme.palette.semantic.bd.default}`,
    padding: '24px 80px'
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.semantic.text.default,
    textAlign: 'center',
    fontVariantNumeric: 'lining-nums tabular-nums',

    /* Headers/H3 */
    fontFamily: 'TT Commons Pro',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '28px' /* 116.667% */
}));

const StyledIconContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    width: '100px',
    height: '100px',
    padding: '22px',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    backgroundColor: theme.palette.semantic.bg.brandLight1,
    borderRadius: '100%',
    '& svg': {
        width: '46px',
        height: '46px'
    }
}));
